import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { useLanguage } from '../../contexts/LanguageContext';
import { GoldBow } from '../GoldBow';

/**
 * Confirmation only. No Queen selection, no auto-redirect, no popup, no countdown —
 * the Queens reach out. The floating WhatsApp control stays available elsewhere on
 * the page for anyone who prefers to start the conversation themselves.
 */
export function SuccessPanel({
  firstName
}: {
  firstName: string;
}) {
  const {
    t
  } = useLanguage();
  const reduce = useReducedMotion();
  return <div className="border border-camel/40 bg-white/[0.04] p-8 text-center sm:p-12" data-id="element-314" data-mp="ns4i7ekxz5ch">
      {/* The gold bow, not a generic check — it is the brand's delivery signature. */}
      <div style={{
      perspective: 800
    }} data-id="element-315" data-mp="xnegbr87yskz">
        <motion.div initial={reduce ? undefined : {
        opacity: 0,
        y: 18,
        rotateX: -35,
        scale: 0.9
      }} animate={{
        opacity: 1,
        y: 0,
        rotateX: 0,
        scale: 1
      }} transition={{
        duration: 0.7,
        ease: [0.22, 1, 0.36, 1]
      }} style={{
        transformStyle: 'preserve-3d'
      }} className="mx-auto flex h-16 w-16 items-center justify-center rounded-full border border-gold/50" data-id="element-316" data-mp="2e2fs38vwn8r0">
          <GoldBow className="h-7 w-9" data-id="element-317" data-mp="2xgngkvjwi1bd" />
        </motion.div>
      </div>

      <h3 className="mt-6 font-display text-2xl font-extrabold uppercase tracking-[0.06em] text-white sm:text-3xl" data-id="element-318" data-mp="2xe9kcjdhij28">
        {t('success.title', {
        name: firstName.toUpperCase()
      })}
      </h3>
      <p className="mx-auto mt-3 max-w-md text-base leading-relaxed text-white/70" data-id="element-319" data-mp="24tjfh1nxi74v">
        {t('success.sub')}
      </p>
    </div>;
}